import React, { useState } from "react";
import PropTypes from "prop-types";
import Title from "../title";
import { FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import { MdMail } from "react-icons/md";
import Sponsor from "../sponsor";
import AppConfig from "../../config/config";
import "./index.scss";

const FormComponent = ({
  address,
  button,
  email,
  excerpt,
  header,
  organization,
  phone,
}) => {
  const [formSubmitted, submitForm] = useState(false);
  const [formValue, updateFormValue] = useState({
    firstName: null,
    lastName: null,
    program: "Any",
    message: null,
  });
  const onSubmitForm = async (e) => {
    e.preventDefault();
    const contactUrl = "/.netlify/functions/form-contact";
    const autoReplyUrl = "/.netlify/functions/auto-reply";

    try {
      await AppConfig.appFetch.post({ url: contactUrl, body: formValue });
      await AppConfig.appFetch.post({ url: autoReplyUrl, body: formValue });

      updateFormValue({
        firstName: null,
        lastName: null,
        program: "Any",
        message: null,
      });
      submitForm(true);
    } catch (error) {
      console.error("Error", error);
    }
  };

  const handleChange = (e) => {
    updateFormValue({
      ...formValue,
      [e.currentTarget.name]: e.currentTarget.value,
    });
  };
  return (
    <section id="contact" className="form__section">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-sm-12">
            <Title header={header} tagline={excerpt} />
            <ul>
              <li>
                <p>
                  <FaMapMarkerAlt /> {address}
                </p>
              </li>
              <li>
                <p>
                  <FaPhone /> {phone}
                </p>
              </li>
              <li>
                <p>
                  <MdMail /> {email}
                </p>
              </li>
            </ul>
          </div>
          {formSubmitted ? (
            <>
              <div className="col-lg-5 col-sm-12 ml-auto align-self-center">
                <h2>Thank you for reaching out</h2>
                <p>
                  Feel free to look at some of our sponsors below. <br />
                  Maybe considering becoming a sponsor as well.
                </p>
              </div>
              <Sponsor />
            </>
          ) : (
            <div className="col-lg-5 col-sm-12 form__main__container">
              <div className="form__container">
                <div className="container">
                  <form
                    name="contact"
                    method="post"
                    data-netlify="true"
                    data-netlify-honeypot="bot-field"
                    onSubmit={onSubmitForm}
                  >
                    <input type="hidden" name="form-name" value="contact" />
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="firstName">First Name</label>
                          <input
                            className="form-control"
                            name="firstName"
                            onChange={handleChange}
                            value={formValue.firstName}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="lastName">Last Name</label>
                          <input
                            className="form-control"
                            name="lastName"
                            onChange={handleChange}
                            value={formValue.lastName}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        onChange={handleChange}
                        value={formValue.email}
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label for="program">Pick the program of interest</label>
                      <select
                        className="form-control"
                        id="program"
                        name="program"
                        onChange={handleChange}
                        value={formValue.program}
                      >
                        <option value="Any">Any</option>
                        {organization.map((program) => (
                          <option value={program}>{program}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="message">Message</label>
                      <textarea
                        className="form-control"
                        name="message"
                        onChange={handleChange}
                        value={formValue.message}
                      />
                    </div>
                    <div className="form__submit__button">
                      <input type="submit" value="Submit" />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

FormComponent.propTypes = {
  address: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  organization: PropTypes.array.isRequired,
};

export default FormComponent;
